import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'modules/common/components/Modal';
import PrintIFrame from 'modules/common/components/PrintIFrame';

import * as c from '../../constant';

function CollectionsAndRemittancesModal({ newData }) {
  const { bearer_token, email, date } = newData

  const url = `${process.env.REACT_APP_WS}${c.DAILY_COLLECTION_URI}?bearer_token=${bearer_token}&email=${email}&date=${date}&output=I`;

  return (
    <Modal.Body>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 px-0 animated-spinner">
            <PrintIFrame url={url} />
          </div>
        </div>
      </div>
    </Modal.Body>
  );
}

CollectionsAndRemittancesModal.propTypes = {
  newData: PropTypes.instanceOf(Object).isRequired,
};

export default CollectionsAndRemittancesModal;
